import { Switch } from "@headlessui/react";
import React, { useState } from "react";
import { IoStar } from "react-icons/io5";
import { ClipLoader } from "react-spinners";
import { toast } from "react-toastify";
import { getApiCaller } from "../../libs/apiCaller";

const ReviewCard = ({ reviewData }) => {
  const { consumer_name, date_time, rating, review, status, id } = reviewData;
  const [enabled, setEnabled] = useState(status || false);
  const [loading, setLoading] = useState(false);

  const updateReviewStatus = async (newStatus, ratingId) => {
    setLoading(true);
    try {
      const response = await getApiCaller(
        `review_status?rating_id=${ratingId}&status=${newStatus ? 1 : 0}`
      );
      if (response.data?.status) {
        toast.success(response.data?.response_message);
      } else {
        toast.error(response.data?.response_message);
      }
    } catch (error) {
      console.error("Error updating status:", error);
      setEnabled(!newStatus); // Revert switch if API fails
    } finally {
      setLoading(false);
    }
  };

  const handleSwitchChange = (ratingId) => {
    const newStatus = !enabled;
    setEnabled(newStatus);
    updateReviewStatus(newStatus, ratingId);
  };

  return (
    <>
      <div
        className="p-4 border rounded-lg shadow-sm mb-4 break-all min-w-[250px] md:min-w-[350px] lg:min-w-[350px]"
        style={{ overflowWrap: "anywhere" }}
      >
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-3">
            {/* <div className="rounded-full flex items-center justify-center font-semibold">
              <img
                src={`https://c8.alamy.com/comp/KEDB24/handsome-young-man-profile-KEDB24.jpg`}
                alt={"profile"}
                className="w-11 h-11 rounded-xl"
              />
            </div> */}
            <div>
              <h3 className="font-semibold">{consumer_name}</h3>
              <p className="text-sm text-gray-500">{date_time}</p>
            </div>
          </div>
          <div className="flex items-center space-x-1">
            <IoStar className="w-5 h-5 text-yellow-400 fill-yellow-400" />
            <span className="font-medium">{rating}</span>
          </div>
        </div>
        <div
          className="break-all max-w-[250px] md:max-w-[300px] lg:max-w-[350px]"
          style={{ overflowWrap: "anywhere" }}
        >
          <span
            className="text-gray-600 mb-4 break-all "
            style={{ overflowWrap: "anywhere" }}
          >
            {review}
          </span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-sm font-semibold">Visible for consumer:</span>
          <div className=" flex gap-2 py-4 px-4">
            <p>OFF</p>

            <Switch
              checked={enabled}
              onChange={() => handleSwitchChange(id)}
              disabled={loading}
              className={`group inline-flex h-6 w-11 items-center rounded-full ${
                loading && enabled ? "justify-end" : "justify-start"
              } transition ${
                enabled ? "bg-[#284184] " : "bg-gray-200 justify-start"
              }`}
            >
              {loading ? (
                <ClipLoader
                  size={20}
                  color="#ffffff"
                  loading={loading}
                  className={`${enabled ? "me-1" : "ms-1"} `}
                />
              ) : (
                <span
                  className={`size-4 rounded-full bg-white transition ${
                    enabled ? "translate-x-6" : "translate-x-1"
                  }`}
                />
              )}
            </Switch>
            <p>ON</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReviewCard;
